import vue from "vue";
import cloneDeep from "lodash.clonedeep";

const state = {
  openedCharts: {},
  chartsData: {},
  chartsLayouts: {},
  activeChart: {},
  activeTab: {},
  chartsStyle: {
    default: {
      lineWidth: 1,
      colors: [
        "#0094FF",
        "#FF4681",
        "#B40097",
        "#FF8B00",
        "#FF2C00",
        "#FFDB00",
        "#62E200",
        "#7D00DE"
      ]
    }
  }
};

const mutations = {
  ADD_CHART_TAB(state, i) {
    vue.set(state.chartsLayouts, i, []);
    vue.set(state.activeTab, "tab", i);
    vue.set(state, "activeChart", {});
  },
  REMOVE_CHART_TAB(state, { i, active }) {
    if (state.chartsLayouts[i]) vue.delete(state.chartsLayouts, i);
    if (!Object.keys(state.chartsLayouts).length) {
      vue.set(state.activeTab, "tab", null);
    } else {
      vue.set(state.activeTab, "tab", active);
    }
    vue.set(state, "activeChart", {});
  },
  CHANGE_ACTIVE_TAB(state, i) {
    vue.set(state.activeTab, "tab", i);
    vue.set(state, "activeChart", {});
  },
  ADD_NEW_CHART(state, { id, type, tab }) {
    if (state.chartsLayouts[tab].length > 2) {
      return;
    }
    const defaultStyle = state.chartsStyle.default;
    const newChartStyles = [];
    for (let i = 0; i < defaultStyle.colors.length; i++) {
      newChartStyles.push({
        lineWidth: defaultStyle.lineWidth,
        border: defaultStyle.colors[i],
        background: defaultStyle.colors[i],
        pointBorder: defaultStyle.colors[i],
        point: defaultStyle.colors[i]
      });
    }
    const newChart = {
      type,
      styles: newChartStyles
    };
    vue.set(state.openedCharts, id, newChart);
    const chartItem = {
      x: 0,
      y: 0,
      w: 6,
      h: 18,
      i: id,
      type: state.openedCharts[id].type,
      active: false,
      changed: false,
      tab
    };
    if (!state.chartsLayouts[tab].find(e => e.i === id)) {
      state.chartsLayouts[tab].push(chartItem);
    }
  },
  CHANGE_CHART_TYPE(state, { chartId, chartType, tab }) {
    vue.set(state.openedCharts[chartId], "type", chartType);
    vue.set(state.activeChart[chartId], "type", chartType);
    state.chartsLayouts[tab].forEach(element => {
      if (element.i === chartId) element.type = chartType;
    });
  },
  CLOSE_CHART(state, { id, tab }) {
    if (state.activeChart[id]) vue.delete(state.activeChart, id);
    if (state.openedCharts[id]) vue.delete(state.openedCharts, id);
    state.chartsLayouts[tab] = state.chartsLayouts[tab].filter(
      item => item.i !== id
    );
  },
  CHANGE_CHART_SOURCE(
    state,
    { source_id, chartName, xAxis, yAxis, chartId, id }
  ) {
    const chartSource = {
      source_id,
      chartName,
      xAxis,
      yAxis,
      chartId,
      id
    };
    vue.set(state.openedCharts[chartId], "source", chartSource);
    vue.set(state.openedCharts[chartId], "updated", true);
  },
  ADD_CHART_DATA(
    state,
    { title, xTitle, column, source_id, fieldsData, chartId, id }
  ) {
    let data = {
      data: fieldsData,
      fieldsTitle: xTitle,
      fields: column,
      updated: true,
      title,
      source_id,
      id
    };

    vue.set(state.chartsData, chartId, data);
    if (state.activeChart[chartId]) {
      vue.set(state.activeChart[chartId], "updated", true);
    }
  },
  SET_ACTIVE_CHART(state, chart) {
    if (JSON.stringify(state.activeChart) !== "{}") {
      state.activeChart = {};
      vue.set(state.activeChart, chart.i, {
        id: chart.i,
        source_id: chart.source_id,
        type: chart.type
      });
    } else {
      vue.set(state.activeChart, chart.i, {
        id: chart.i,
        source_id: chart.source_id,
        type: chart.type
      });
    }
  },
  DEACTIVATE_CHARTS(state) {
    vue.set(state, "activeChart", {});
  },
  SET_CHART_STYLE_CONFIG(state, { id, propName, value, i }) {
    switch (propName) {
      case "lineWidth":
        vue.set(state.openedCharts[id].styles[i], "lineWidth", value);
        break;
      case "border":
        vue.set(state.openedCharts[id].styles[i], "border", value);
        break;
      case "background":
        vue.set(state.openedCharts[id].styles[i], "background", value);
        break;
      case "pointBorder":
        vue.set(state.openedCharts[id].styles[i], "pointBorder", value);
        break;
      case "point":
        vue.set(state.openedCharts[id].styles[i], "point", value);
        break;
      default:
        break;
    }
    vue.set(state.openedCharts[id], "updated", "style");
  },
  CHANGE_CHART_LAYOUT(state, config) {
    let chartNo;
    state.chartsLayouts[config.tab].forEach((e, n) => {
      if (e.i === config.chartId) chartNo = n;
    });
    switch (config.event) {
      case "moved":
        state.chartsLayouts[config.tab][chartNo].x = config.x;
        state.chartsLayouts[config.tab][chartNo].y = config.y;
        break;
      case "resized":
        state.chartsLayouts[config.tab][chartNo].h = config.h;
        state.chartsLayouts[config.tab][chartNo].w = config.w;
        break;
      default:
        break;
    }
  },
  CHARTS_DUPLICATE(state, { duplicatorId, newId }) {
    const duplicateData = cloneDeep(state.openedCharts[duplicatorId]);
    if (!duplicateData.source) return;
    duplicateData.source.chartId = newId;
    vue.set(state.openedCharts, newId, duplicateData);
  }
};

export default {
  state,
  mutations
};
